import { SVG } from '../SVG'

const ClockIcon = ({ color = 'var(--primary-color)', style = {}, ...props }) => (
  <SVG
    width='55'
    height='55'
    viewBox='0 0 55 55'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ stroke: color, ...style }}
    {...props}
  >
    <path d='M27.5 15.4688V27.5H39.5312' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M27.5 46.4062C37.9416 46.4062 46.4062 37.9416 46.4062 27.5C46.4062 17.0584 37.9416 8.59375 27.5 8.59375C17.0584 8.59375 8.59375 17.0584 8.59375 27.5C8.59375 37.9416 17.0584 46.4062 27.5 46.4062Z'
      strokeWidth='2'
      strokeMiterlimit='10'
    />
    <path d='M42.0879 5.62891L49.3711 12.9121' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M5.62891 12.9121L12.9121 5.62891' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </SVG>
)

export default ClockIcon
